import {
    PROJECTSVIEW_UPDATE_PRODUCT,
    PROJECTSVIEW_UPDATE_PARENT_PROJECT,
    PROJECTSVIEW_UPDATE_COMMERCIAL_PROJECT,
    PROJECTSVIEW_CLEAN
} from 'reducers/constants';

const initialState = initState();


function initState() {
    return {
        parentProject: null,
        commercialProject: null,
        product: null
    };
}

export default function (state = initialState, action) {
    switch (action.type) {

        case PROJECTSVIEW_UPDATE_PRODUCT:
            return {
                ...state,
                product: action.payload != null ? Object.assign({}, action.payload) : null
            }

        case PROJECTSVIEW_UPDATE_PARENT_PROJECT:
            return {
                ...state,
                parentProject: Object.assign({}, action.payload)
            }

        case PROJECTSVIEW_UPDATE_COMMERCIAL_PROJECT:
            return {
                ...state,
                commercialProject: action.payload != null ? Object.assign({}, action.payload) : null
            }

        case PROJECTSVIEW_CLEAN:
            return {
                parentProject: null,
                commercialProject: null,
                product: null
            }

        default:
            return state;

    }
}


// WEBPACK FOOTER //
// ./src/reducers/projectsview/projectsviewReducer.js